<template>
    <div v-if="isAvailable">
        <b-btn :id="`rating_${contract.id}`" class="btn btn-card-action btn-card-action my-1" @click="ratingModalVisible = $store.getters.getCanSign && true">Оценить {{ contract.flags.is_supplier ? 'заказчика' : 'поставщика' }} </b-btn>
        <b-popover v-if="!$store.getters.getCanSign" :target="`rating_${contract.id}`" triggers="hover">
            <span v-if="$store.getters.getLoginType === 'cert'" class="fs-12">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
            <span v-else class="fs-12">Для действия требуется авторизация при помощи ЭЦП</span>
        </b-popover>
        <b-modal v-model="ratingModalVisible" :title="'Оцените ' + (contract.flags.is_supplier ? 'заказчика' : 'поставщика')" @hide="hide" @close="hide" body-class="pt-0" centered no-close-on-backdrop no-close-on-esc hide-header-close>
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <b-row class="feedback_modal">
                <b-col>
                    <b-form class="px-2" @submit.prevent="onSubmitRating">
                        <b-row class="py-2" no-gutters>
                            <b-col class="fs-14 grey-color">
                                <h5 class="grey-color">{{ contract.flags.is_supplier ? contract.customer.name : contract.supplier.name }}</h5>
                            </b-col>
                        </b-row>
                        <star-rating v-model="form.rating" :text-class="`fw-600 rating-text ${ratingTextClass}`" />
                        <form-row-edit-textarea v-model="form.comment" :v="$v.form.comment" label="Комментарий" :rows="5" class="mb-0 pt-2" label-on-top />
                    </b-form>
                </b-col>
            </b-row>
            <template #modal-footer>
                <b-overlay :show="ratingSending" rounded opacity="0.6" spinner-small spinner-variant="primary">
                    <b-button class="mr-2 text-uppercase" type="reset" variant="custom-outline-secondary" @click="hide">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="ratingSending" rounded opacity="0.6" spinner-small spinner-variant="primary">
                    <b-button :disabled="$v.$invalid" class="text-uppercase" type="submit" variant="custom-green" @click="onSubmitRating">Отправить</b-button>
                </b-overlay>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import StarRating from 'vue-star-rating';

export default {
    name: 'cabinet-fl44-notice-card-rate-button',
    components: {
        StarRating
    },
    props: {
        contract: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                rating: null,
                comment: '',
                is_customer_rating: this.contract.flags.is_supplier
            },
            ratingModalVisible: false,
            ratingSending: false
        };
    },
    validations: {
        form: {
            rating: {
                required
            },
            comment: {
                required: requiredIf((form) => (!form.is_customer_rating && form.rating < 4) || (form.is_customer_rating && form.rating < 5))
            }
        }
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        hide() {
            this.ratingModalVisible = false;
            this.cancelRatingModal();
        },
        cancelRatingModal() {
            this.form.rating = null;
            this.form.comment = '';
            this.ratingSending = false;
        },
        async onSubmitRating() {
            this.ratingSending = true;
            await this.$api.personal[this.contract.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume']
                .storeRating(this.form, this.contract.id)
                .then(() => {
                    this.cancelRatingModal();
                    this.refresh();
                })
                .catch(() => {})
                .finally(() => {
                    this.ratingModalVisible = false;
                    this.ratingSending = false;
                });
        }
    },
    computed: {
        ratingTextClass() {
            switch (this.form.rating) {
                case 4:
                    return 'rating-text-yellow';
                case 5:
                    return 'rating-text-green';
                default:
                    return 'rating-text-danger';
            }
        },
        isAvailable() {
            return this.contract.actions.rating_allowed || this.contract.actions.customer_rating_allowed;
        }
    }
};
</script>

<style>
.rating-text {
    margin-left: 165px !important;
    font-size: 63px;
}
.rating-text-green {
    color: var(--green-color);
}
.rating-text-yellow {
    color: var(--yellow-color);
}
.rating-text-danger {
    color: var(--danger);
}
</style>
